/**
 * @file   : Info.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 3/25/2019, 7:06:35 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Cont from '../../external/components/layout/Cont'
import MetaData from '../../external/components/meta/MetaData'
import {
  getKeyQualifiersForInfo,
  getLiteralValuesForInfo,
} from '../../utilities/MetaDataUtils'
import InfoLayout from './InfoLayout'

const PAGE_ID = 'PAGE_INFO'

class InfoContainer extends Component {
  render() {
    const { theme, intl, infoData, mainConfig, metaConfig } = this.props

    return (
      <Cont>
        <MetaData
          intlObj={intl}
          literalValues={getLiteralValuesForInfo(mainConfig, infoData)}
          data={metaConfig}
          pageId={PAGE_ID}
          keyQualifiers={getKeyQualifiersForInfo(infoData)}
        />
        <InfoLayout
          theme={theme}
          intl={intl}
          infoData={infoData}
          mainConfig={mainConfig}
        />
      </Cont>
    )
  }
}

// eslint-disable-next-line one-var, no-unused-vars
const mapStateToProps = function (state, props) {
    return {
      theme: state.application.theme,
      intl: state.backend.intl,
      infoData: state.backend.info.currentItem,
      mainConfig: state.backend.config.main,
      metaConfig: state.backend.config.meta,
    }
  },
  // eslint-disable-next-line no-unused-vars
  mapDispatchToProps = function (dispatch, ownProps) {
    return {
      test: () => {},
    }
  }

InfoContainer.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  infoData: PropTypes.object.isRequired,
  mainConfig: PropTypes.object.isRequired,
  metaConfig: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoContainer)
